jQuery(($) => {

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // Animation: GotoHash
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    function goToHash(hash) {
        var adminBarHeight = 0;

        if ($('#wpadminbar').length) {
            adminBarHeight = $('#wpadminbar').innerHeight();
        }

        var offset = $(hash).offset().top - 50 - adminBarHeight;

        $('html, body').animate({
            scrollTop: offset
        }, 500, function () {
            if (history.pushState) {
                history.pushState(null, null, hash);
            } else {
                location.hash = hash;
            }
        });
    }
 
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟HashButton
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    $('.js-hash').click(function (e) {
        e.preventDefault();
        var hash = this.hash;

        goToHash(hash);
    });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // Animation: Animate On Scroll
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if ($('[data-aos]')[0]) {
        AOS.init({ // jshint ignore:line
            once: true,
            anchorPlacement: 'top-bottom'
        });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Browser - Keydown Focus Class
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('body').on('keydown', function () {
        if (!$('.keyboard-in-use')[0]) {
            $(this).addClass('keyboard-in-use');
        }
    });

    $('body').on('mousedown', function () {
        if ($('.keyboard-in-use')[0]) {
            $(this).removeClass('keyboard-in-use');
        }
    });

//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
// _Header
//≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

var $header_toggle   = $('.o-header .js-mobile-toggle'),
    $header_nav_list = $('.o-header .m-page-nav__list');

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟MenuToggle
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    $header_toggle.click(function () {
        if ($('.o-header__wrapper--open')[0]) {
            $('body').removeAttr('style');
        } else {
            $('body').css('overflow', 'hidden');
        }

        $(this).toggleClass('a-hamburger--toggled');
        $('.o-header__wrapper').toggleClass('o-header__wrapper--open');
    });


    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Accessibility
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    if ($header_toggle[0]) {
        // On Toggle Keydown
        $header_toggle.keydown(function (e) {

            if (e.key === 'Enter') {
                e.preventDefault();

                $('.o-header__wrapper').toggleClass('o-header__wrapper--open');

                if ($('.o-header__wrapper').hasClass('o-header__wrapper--open')) {
                    $header_nav_list.attr('aria-expanded', 'true');
                    $(this).attr('aria-pressed', 'true');
                    $(this).addClass('a-hamburger--toggled');
                    $('body').css('overflow', 'hidden');

                } else {
                    $header_nav_list.attr('aria-expanded', 'false');
                    $(this).attr('aria-pressed', 'false');
                    $(this).removeClass('a-hamburger--toggled');
                    $('body').removeAttr('style');
                }

                setTimeout(function () {
                    list.find("li:first-child a").focus();
                }, 0);
            }
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Atom: Select
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    function openSelectList(el) {
        const $select = $(el).closest(".a-select");
        const $list = $select.find(".a-select__list");
        const $option = $list.find(
            ".a-select__item--selected, .a-select__item:first-child"
        );

        $select.addClass("a-select--open");
        $list.show();
        $option.focus();
    }

    function closeSelectList(el) {
        const $select = $(el).closest(".a-select");
        const $input = $select.find(".a-select__input");
        const $list = $select.find(".a-select__list");

        $select.removeClass("a-select--open");
        $list.hide();
        $input.focus();
    }

    function toggleSelectList(el) {
        const $select = $(el).closest(".a-select");
        const $list = $select.find(".a-select__list");

        if ($list.is(":visible")) {
            closeSelectList(el);
        } else {
            openSelectList(el);
        }
    }

    function searchSelectList(el, query) {
        const $select = $(el).closest(".a-select");
        const $items = $select.find(".a-select__item");

        const queryText = query.trim().toLowerCase();

        $items
            .filter(function () {
                const itemText = $(this)
                    .text()
                    .trim()
                    .toLowerCase();
                return itemText.indexOf(queryText) === 0;
            })
            .first()
            .focus();
    }

    function chooseSelectOption(el) {
        const $select      = $(el).closest(".a-select");
        const $nSelect     = $select.find(".a-select__native");
        const $input       = $select.find(".a-select__input .a-select__input-text");
        const $items       = $select.find(".a-select__item");
        const $tabsParent  = $select.parents('.m-tabs');
        const $activeIndex = $(el).index();
        const $tabItem     = $tabsParent.find('.m-tab-list__item');
        const $activeTab   = $tabItem.eq($activeIndex);
        const $activeChild = $activeTab.find('.a-tab');

        if ($tabsParent.hasClass('m-tabs--mobile-select')) {
            activateTab($activeTab);
            deactivateTab($tabItem.not($activeTab));

            openTabPanel($activeChild);
        }

        $items
            .removeClass("a-select__item--selected")
            .attr("aria-selected", "false");

        $(el)
            .addClass("a-select__item--selected")
            .attr("aria-selected", "true");

        const label = $input.data("label");
        const value = $(el).text();
        const position = $(el).index() + 1;
        const count = $input.data("count");

        const ariaLabel = `${label}, ${value} Selected, ${position} of ${count}`;

        $input.text($(el).text()).attr("aria-label", ariaLabel);
        $select.removeClass("a-select--unset");
        $nSelect.val($(el).data("value"));

        closeSelectList(el);
    }

    if ($(".a-select")[0]) {
        $(".a-select__input").mousedown(function (e) {
            e.preventDefault();
            toggleSelectList(this);
        });

        $(".a-select__input").keydown(function (e) {
            switch (e.key) {
                case "Enter":
                case "spacebar":
                case " ":
                case "ArrowDown":
                case "ArrowUp":
                    e.preventDefault();
                    openSelectList(this);
                    break;

                case "Escape":
                case "Esc":
                case "Delete":
                case "Backspace":
                    e.preventDefault();

                    if ($(this).data("placeholder")) {
                        const $select = $(this).closest(".a-select");
                        const placeholder = $(this).data("placeholder");
                        const label = $(this).data("label");

                        $select.addClass("a-select--unset");
                        $select.find(".a-select__native").val("");
                        $select
                            .find(".a-select__item")
                            .removeClass("a-select__item--selected")
                            .attr("aria-selected", "false");

                        $(this)
                            .text(placeholder)
                            .attr("aria-label", label)
                            .blur()
                            .focus();
                    }
                    break;
            }
        });

        $(".a-select__item").mousedown(function (e) {
            e.preventDefault();
            chooseSelectOption(this);
        });

        $(".a-select__item").blur(function (e) {
            const newTarget = e.relatedTarget;

            if (
                newTarget === null ||
                !newTarget.classList.contains("a-select__item") ||
                e.target.offsetParent != newTarget.parentElement
            ) {
                closeSelectList(this);
            }
        });

        let searchTimeout = false;
        let searchQuery = "";

        $(".a-select__item").keydown(function (e) {
            e.preventDefault();

            switch (e.key) {
                case "Enter":
                case "spacebar":
                case " ":
                    chooseSelectOption(this);
                    break;

                case "Escape":
                case "Esc":
                case "Tab":
                case "Delete":
                case "Backspace":
                    closeSelectList(this);
                    break;

                case "ArrowUp":
                    var prevItem = e.target.previousElementSibling;
                    if (prevItem) prevItem.focus();
                    break;

                case "ArrowDown":
                    var nextItem = e.target.nextElementSibling;
                    if (nextItem) nextItem.focus();
                    break;

                case "Home":
                    $(this)
                        .parent()
                        .find(".a-select__item:first-child")
                        .focus();
                    break;

                case "End":
                    $(this)
                        .parent()
                        .find(".a-select__item:last-child")
                        .focus();
                    break;

                default:
                    searchQuery += e.key;

                    searchSelectList(this, searchQuery);

                    if (searchTimeout) clearTimeout(searchTimeout);

                    searchTimeout = setTimeout(function () {
                        searchQuery = "";
                    }, 1000);
            }
        });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Atom: Tab
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    function openTabPanel(el) {
        const controlId = $(el).attr("aria-controls");
        const $panel = $(`#${controlId}`);
        const $panelList = $panel.closest(".m-tab-panels");

        $panel.show();

        if ($panelList) {
            $panelList
                .find(".m-tab-panel")
                .not($panel)
                .hide();
        }
    }

    if ($(".a-tab")[0]) {
        $(".a-tab").click(function () {
            openTabPanel(this);
        });

        $(".a-tab").keydown(function (e) {
            const $list = $(this).closest(".m-tab-list__list");
            const isAutomatic = $list[0] && $list.data("automatic");

            if (!isAutomatic) {
                if (e.key === "Enter" || e.key === "spacebar" || e.key === " ") {
                    openTabPanel(this);
                }
            }
        });

        $(".a-tab").focus(function (e) {
            const $list = $(this).closest(".m-tab-list__list");
            const isAutomatic = $list[0] && $list.data("automatic");

            if (isAutomatic) openTabPanel(this);
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Molecule: Tab List
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    function activateTab(el) {
        const $item = $(el).closest(".m-tab-list__item");
        const $tab  = $item.find(".m-tab-list__tab");

        $item.addClass("m-tab-list__item--selected");

        $tab.attr("aria-selected", "true").removeAttr("tabindex");
    }

    function deactivateTab(el) {
        const $item = $(el).closest(".m-tab-list__item");
        const $tab  = $item.find(".m-tab-list__tab");

        $item.removeClass("m-tab-list__item--selected");

        $tab.attr("aria-selected", "false").attr("tabindex", -1);
    }

    if ($(".m-tab-list")[0]) {
        $(".m-tab-list__tab").click(function () {
            const $tabs         = $(this).closest('.m-tab-list').find('.m-tab-list__tab');
            const $parentTab    = $(this).parents('.m-tabs');
            const $activeParent = $(this).parent();
            const $activeIndex  = $activeParent.index();
            const $select       = $parentTab.find('.a-select');
            const $item         = $select.find('.a-select__item');
            const $activeItem   = $item.eq($activeIndex);

            activateTab(this);
            deactivateTab($tabs.not(this));

            if ( $parentTab.hasClass('m-tabs--mobile-select') ) {
                chooseSelectOption($activeItem);
            }
        });

    $(".m-tab-list__tab").keydown(function (e) {
        const $list = $(this).closest(".m-tab-list__list");
        const $tabs = $list.find(".m-tab-list__tab");
        const isAutomatic = $list.data("automatic");

        switch (e.key) {
            case "Enter":
            case "spacebar":
            case " ":
                if (!isAutomatic) {
                    e.preventDefault();
                    activateTab(this);
                    deactivateTab($tabs.not(this));
                }
                break;

            case "ArrowLeft":
                e.preventDefault();
                const $prevItem     = $(this).closest(".m-tab-list__item").prev();
                var $parentTab    = $prevItem.parents('.m-tabs');
                var $activeIndex  = $prevItem.index();
                var $select       = $parentTab.find('.a-select');
                var $item         = $select.find('.a-select__item');
                var $activeItem   = $item.eq($activeIndex);

                if ($prevItem[0]) {
                    const $prevTab = $prevItem.find(".m-tab-list__tab");

                    $prevTab.focus();

                    if (isAutomatic) {
                        activateTab($prevTab);
                        deactivateTab(this);
                    }

                    if ((isAutomatic) && $parentTab.hasClass('m-tabs--mobile-select')) {
                        chooseSelectOption($activeItem);
                    }
                }
                break;

            case "ArrowRight": 
                e.preventDefault();
                const $nextItem  = $(this).closest(".m-tab-list__item").next();
                var $parentTab   = $nextItem.parents('.m-tabs');
                var $activeIndex = $nextItem.index();
                var $select      = $parentTab.find('.a-select');
                var $item        = $select.find('.a-select__item');
                var $activeItem  = $item.eq($activeIndex);

                if ($nextItem[0]) {
                    const $nextTab = $nextItem.find(".m-tab-list__tab");

                    $nextTab.focus();

                    if (isAutomatic) {
                        activateTab($nextTab);
                        deactivateTab(this);
                    }

                    if ((isAutomatic) && $parentTab.hasClass('m-tabs--mobile-select')) {
                        chooseSelectOption($activeItem);
                    }
                }
                break;

            case "Home":
                e.preventDefault();
                const $firstTab = $list
                    .find(".m-tab-list__item")
                    .first()
                    .find(".m-tab-list__tab");

                $firstTab.focus();

                if (isAutomatic) {
                    activateTab($firstTab);
                    deactivateTab(this);
                }
                break;

            case "End":
                e.preventDefault();
                const $lastTab = $list
                    .find(".m-tab-list__item")
                    .last()
                    .find(".m-tab-list__tab");

                $lastTab.focus();

                if (isAutomatic) {
                    activateTab($lastTab);
                    deactivateTab(this);
                }
                break;
        }
    });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Function: Update Pagination
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    function updatePagination(index, el_parent) {
        var parent_el     = el_parent,
            pagination    = parent_el.find('.o-featured-typeface__nav .o-featured-typeface__slider-pagination'),
            right_arrow   = parent_el.find('.js-navigate-right'),
            left_arrow    = parent_el.find('.js-navigate-left'),
            number        = pagination.find('.m-slider-pagination__number'),
            number_length = number.length - 1,
            value         = index,
            activeNumber  = number.eq(value);

        number.removeClass('m-slider-pagination__number--is-active');
        activeNumber.addClass('m-slider-pagination__number--is-active');

        right_arrow.removeClass('a-arrow-button--hide');
        left_arrow.removeClass('a-arrow-button--hide');

        if (activeNumber.index() == 0) {
            left_arrow.addClass('a-arrow-button--hide');
        }
        if (number_length == activeNumber.index()) {
            right_arrow.addClass('a-arrow-button--hide');
        }
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Function: Change Typeface
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    function changeTypeface(value, el_parent) {
        var related_el      = el_parent,
            active_title    = value,
            typefaces       = related_el.find('.o-featured-typeface__typefaces .m-typefaces__list'),
            typeface        = typefaces.find('.m-typefaces__item .a-typeface'),
            currentTypeface = typefaces.find('.m-typefaces__item--is-active');

        typeface.each(function () {
            var title = $(this).data('title');

            if (title == active_title) {
                currentTypeface.removeClass('m-typefaces__item--is-active');
                $(this).parent().addClass('m-typefaces__item--is-active');
            }
        });

        var activeTypeface = typefaces.find('.m-typefaces__item--is-active'),
            index          = activeTypeface.index();

        updatePagination(index, el_parent);
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Function: Paginate Typefaces
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    //direction equals either prev or next

    function paginateTypefaces(direction, el_parent) {
        var direct      = direction,
            related_el  = el_parent,
            typefaces   = related_el.find('.o-featured-typeface__typefaces .m-typefaces__list'),
            currentItem = typefaces.find('.m-typefaces__item--is-active');

        if (direct == 'prev') {
            var nextItem = currentItem.prev();
        } else if (direct == 'next') {
            var nextItem = currentItem.next();
        }

        var nextTypeface  = nextItem.find('.a-typeface'),
            nextItemIndex = nextItem.index(),
            data_title    = nextTypeface.data('title'),
            select        = related_el.find('.o-featured-typeface__nav .m-field__select'),
            item          = select.find('.a-select__item'),
            activeItem    = item.eq(nextItemIndex);

        chooseSelectOption(activeItem);

        changeTypeface(data_title, el_parent);
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Organism: Featured Typeface
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if ($('.o-featured-typeface__typefaces .m-typefaces__list')[0]) {
        $('.o-featured-typeface__nav .a-select__item').mousedown(function (e) {
            var select       = $(this).closest('.o-featured-typeface__nav .m-field__select'),
                values_array = [],
                el_parent    = $(this).parents('.o-featured-typeface');

            select.each(function () {
                var active      = $(this).find('.a-select__item--selected'),
                    data_value  = active.attr('data-value');

                values_array.push(data_value);
            });

            var value = values_array + '';

            changeTypeface(value, el_parent);
        });

        $('.o-featured-typeface__nav .a-select__item').keydown(function (e) {
            var select       = $(this).closest('.o-featured-typeface__nav .m-field__select'),
                values_array = [],
                el_parent    = $(this).parents('.o-featured-typeface');

            select.each(function () {
                var active      = $(this).find('.a-select__item--selected'),
                    data_value  = active.attr('data-value');

                values_array.push(data_value);
            });

            var value = values_array + '';

            changeTypeface(value, el_parent);
        });

        $('.js-navigate-left').click(function () {
            var direction = 'prev',
                el_parent = $(this).parents('.o-featured-typeface');

            paginateTypefaces(direction, el_parent);
        });

        $('.js-navigate-right').click(function () {
            var direction = 'next',
                el_parent = $(this).parents('.o-featured-typeface');

            paginateTypefaces(direction, el_parent);
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Function: Change Card
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    function changeCard (values) {
        var cards         = $('.o-message-card-selector__message-cards .m-message-cards__list'),
            card          = cards.find('.m-message-cards__message-card'),
            currentCard   = cards.find('.m-message-cards__item--is-active'),
            active_values = values;

        card.each(function(){
            var tagline = $(this).data('tagline');

            if ( tagline == active_values ) {
                currentCard.removeClass('m-message-cards__item--is-active');
                $(this).parent().addClass('m-message-cards__item--is-active');
            }
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Organism: Message Card Selector
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if ($('.o-message-card-selector')[0]) {
        $('.o-message-card-selector__fields .a-select__item').mousedown(function (e) {
            var select       = $('.o-message-card-selector .o-message-card-selector__field'),
                values_array = [];

            select.each(function() {
                var active = $(this).find('.a-select__item--selected'),
                    value  = active.attr('data-value');

                values_array.push(value);
            });

            var values = values_array + '';

            changeCard(values);
        });
    }

});